import api from 'Application/api/api';

const deleteRfep = (signal, tenderId) =>
	api.delete(`/tenders/${tenderId}`, {
		signal,
	});

export default deleteRfep;
